import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCheckUserExistsMutation } from '../../api-integration/secure/api.kiosk';
import { normalizeAPIResponse } from '../../util/normalizeAPIResponse';
import { LoadingSpinner } from '../../components/common/loading-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { updateKioskFlags } from '../../api-integration/kioskAuthSlice';

type HandleRoutingParams = {
    isValidToken: boolean;
    isConsentProvided: boolean;
    isPhoneVerified: boolean;
    isLoggedIn: boolean
};


const KioskHandler = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const kioskInviteToken = new URLSearchParams(location.search).get("kioskInviteToken");

    // Read isLoggedIn from Redux — verified server state, not localStorage
    const { isLoggedIn } = useSelector((state: any) => state.kioskAuthSlice);

    const [checkUserExistsAPI, checkUserExistsResult] = useCheckUserExistsMutation();

    const handleRouting = ({isValidToken,isConsentProvided,isPhoneVerified, isLoggedIn}: HandleRoutingParams) => {
        if (!isValidToken) {
            navigate('/invalid-invite', { replace: true });
            return;
        }
        if (!isConsentProvided) {
            navigate('/consent', { replace: true });
            return;
        }
        if (!isLoggedIn) {
            navigate('/login', { replace: true });
            return;
        }
        if (!isPhoneVerified) {
            navigate('/verify', { replace: true });
            return;
        }
        navigate('/home', { replace: true });
    };

    useEffect(() => {
        if (!kioskInviteToken) {
            navigate('/invalid-invite', { replace: true });
            return;
        }
        localStorage.setItem("kioskInviteCode", kioskInviteToken);
        checkUserExistsAPI({ kioskInviteToken: kioskInviteToken });
    }, [kioskInviteToken]);

    useEffect(() => {
        if(checkUserExistsResult?.isSuccess || checkUserExistsResult?.isError) {
            const response = normalizeAPIResponse(checkUserExistsResult);
            if(response?.success === true) {
                const userDetails = response?.data?.userDetails || {};
                const isConsentProvided = userDetails?.isConsentProvided ?? false;
                const isPhoneVerified = userDetails?.isPhoneVerified ?? false;
                
                dispatch(updateKioskFlags({
                    isConsentProvided,
                    isPhoneVerified
                }));

                handleRouting({
                    isValidToken: true,
                    isConsentProvided,
                    isPhoneVerified,
                    isLoggedIn,
                });
            }
            else {
                handleRouting({
                    isValidToken: false,
                    isConsentProvided: false,
                    isPhoneVerified: false,
                    isLoggedIn,
                });
            }
        }
    },[checkUserExistsResult?.isSuccess, checkUserExistsResult?.isError]);

    // While processing, show a loading indicator
    return (
        <div>
            <LoadingSpinner />
        </div>
    )
};

export default KioskHandler;